import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CallLogsSearchBox = () => {
  let navigate = useNavigate();

  const [keyword, setKeyword] = useState('');
  const submitHandler = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      navigate(`/${keyword}`);
    } else {
      navigate('/');
    }
  };
  return (
    <form onSubmit={submitHandler} className='w-full' dir='rtl'>
      <div className='flex justify-center w-full py-6'>
        <input
          type='text'
          className='w-4/5 p-1 rounded py-2 pr-3 shadow-md'
          name='q'
          onChange={(e) => setKeyword(e.target.value)}
          placeholder='ابحث عن الزبون عن طريق رقم الهاتف'
        ></input>
        <button
          type='submit'
          variant='outline-success'
          className='ml-2 bg-button-100 hover:bg-blue-800 text-white px-4 rounded shadow-md'
        >
          بحث
        </button>
      </div>
    </form>
  );
};

export default CallLogsSearchBox;
